ui-cms-text-image-video {
  display: block;

  .video-info-message {
    @extend %caption;

    color: $ui-grey-plus-1;
    margin: 0;
    padding: 4px;

    &::before {
      @include getIcon('\e61a');

      margin-right: 4px;
    }
  }

  ui-cms-footnote-list {
    margin-top: 24px;
  }

  ui-cms-link-list {
    margin-top: 30px;
  }
}
